import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, IconX, LocaleX, ReqX, ZTime, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XDiv, XIconButton, XImage, XScroll, XText } from "IZOX/_X";
import PolicyUtils from "shared/_utils/PolicyUtils";
import _ from "lodash";
import ReceiptUtils from "shared/_utils/ReceiptUtils";
import { HiDownload } from "react-icons/hi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { QForm } from "IZOX/BLOCKS/Libs";
import { QFDropUpload } from "IZOX/BLOCKS/Libs/QForm/_gears";


/**
 * @augments {Component<Props, State>}
 */
class PAPopupReceipts extends Component {

  static propTypes = {
    policyDoc: PropsType.any,
    receiptDocs: PropsType.array
  }

  static defaultProps = {
    policyDoc: {},
    receiptDocs: []
  }

  constructor(){
    super();
    this.state = {
      page: "view",
      formValue: {}
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAPopupReceipts.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  onMountQForm = (callbacks) => {
    this.MountQForm = callbacks;
  }

  _onFormChange = (formValue) => {
    this.setState({
      formValue: formValue
    });
  }

  _toClose = () => {
    let {refresh} = this.props;
    refresh?.();
    GFunc.CloseBackdrop();
  }

  _toUpload = () => {
    this.setState({
      page: "upload"
    });
  }

  _validateForm = () => {
    let {formValue} = this.state;
    let valid = true;
    valid = ZValidate.CheckAllFields(formValue, ["upload"], "required");
    if(!valid) return false;
    valid = ZValidate.CheckUploads(formValue, ["upload"]);
    if(!valid) return false;
    return true;
  }

  _toView = () => {
    this.setState({
      page: "view"
    });
  }

  _toSuccess = () => {
    this.setState({
      page: "thank"
    });
  }

  _Preview = (receipt) => {
    let {attachments} = receipt;
    if(attachments?.[0]){
      GFunc.ViewIZOXImage(attachments?.[0]);
    }
  }

  _Download = (receipt) => {

  }

  _toSubmit = async () => {
    let {policyDoc} = this.props;
    let {formValue} = this.state;
    formValue._isReceipt = true;
    let res = await ReqX.SendBE("/Web/Agent/UploadAtth", {
      docIDs: [policyDoc._id],
      formValue
    });
    let {Success} = res;
    if(Success){
      this._toSuccess();
    }else{
      GFunc.Ask({
        EN: "Network problem.",
        TC: "網絡問題"
      },
      {
        EN: "Please try again later.",
        TC: "請稍後再試。"
      });
    }
  }

  renderHeader(){
    return (
      <HStack pH={16} shadow>
        <XText bold color={ColorX.CSS("Stone")}>
          {LocaleX.Parse({
            EN: "Receipt details",
            TC: "收據詳情"
          })}
        </XText>
        <Spacer/>
        <XButton onPress={this._toClose}>
          {IconX.Get("ant", "close", 20, ColorX.CSS("Stone"))}
        </XButton>
      </HStack>
    );
  }

  renderPolicy(){
    let {policyDoc} = this.props;
    let {policyNo, runtimeStatus} = policyDoc;
    let _status = PolicyUtils.GetStatus(runtimeStatus);
    return (
      <HStack bgColor={ColorX.CSS(_status?.color)} 
        spacing={5} HAlign="[" pV={10} pH={15}>
        <XText color={ColorX.CSS("pureWhite")} bold>
          {LocaleX.Parse({
            EN: "Policy no.",
            TC: "保單編號"
          })}
        </XText>
        <XText color={ColorX.CSS("pureWhite")} bold>
          {policyNo}
        </XText>
        <Spacer/>
        <XDiv bgColor={_status?.bgColor} pH={8} width={92}>
          <XText color={_status?.color} textAlign="|" fontSize={14}>
            {LocaleX.Parse(_status?.label)}
          </XText>
        </XDiv>
      </HStack>
    );
  }

  renderReceipt(receipt, idx){
    let {_id, policyNo, status, createdAt} = receipt;
    let _status = ReceiptUtils.GetStatus(status);
    return (
      <HStack bgColor={ColorX.CSS("bgGreen")} p={16} mB={8} key={idx}>
        <VStack fitWidthToContent HAlign="[">
          <XText fontSize={10} color={ColorX.CSS("Stone")}>
            {`${ZTime.Moment(createdAt).format("DD/MM/YYYY - HH:mm")}`}
          </XText>
          <HStack HAlign="[" spacing={5}>
            <XText color={ColorX.CSS("Leaf")} fontSize={12}>
              {LocaleX.Parse({
                EN: "Receipt no.",
                TC: "收據編號"
              })}
            </XText>
            <XText bold color={ColorX.CSS("Leaf")} fontSize={18}>
              {`#${policyNo ?? _id}`}
            </XText>
          </HStack>
        </VStack>
        <Spacer/>
        <HStack fitWidthToContent spacing={10}>
          {(status === "Submitted" || status === "Unpaid") &&
            <XDiv pH={5} mR={10} width={150} bgColor={_status?.bgColor} fitWidthToContent>
              <XText fontSize={12} color={_status?.color}>
                {LocaleX.Parse(_status?.label)}  
              </XText>  
            </XDiv>}
          <XIconButton onPress={() => this._Download(receipt)}
            bgColor={ColorX.CSS("RenewedBg")} padding={3}>
            <HiDownload color={ColorX.CSS("Leaf")} size={12}/>
          </XIconButton>
          <XIconButton onPress={() => this._Preview(receipt)}
          padding={4} bgColor={ColorX.CSS("ActiveBg")}>
            <XImage source={"/Images/Icons/picture_pre.svg"} width={12} height={12}/>
          </XIconButton>
        </HStack>
      </HStack>
    );
  }

  renderView(){
    let {receiptDocs} = this.props;
    return (
      <XScroll style={{maxHeight: 450}} p={8}>
        {_.map(receiptDocs, (o, i) => {
          return this.renderReceipt(o, i);
        })}
      </XScroll>
    );
  }

  renderUpload(){
    let {formValue} = this.state;
    return (
      <QForm mV={20} onChange={this._onFormChange} value={formValue}>
         <QFDropUpload 
          btnBgColor={ColorX.CSS("Axit")}
          color={ColorX.CSS("Stone")}
          previewColor={ColorX.CSS("Leaf")}
          fileSizeLimit={10} 
          instantUpload 
          name={"upload"} 
          accept=".jpg,.png,.pdf,.jpeg" 
          multiple/>
      </QForm>
    );
  }

  renderThank(){
    return (
      <VStack pH={16} pV={100} bgColor={ColorX.CSS("pureWhite")} mT={16}>
        <XText color={ColorX.CSS("Leaf")} bold fontSize={28}>
          {LocaleX.Parse({
            EN: "Thank You",
            TC: "多謝"
          })}
        </XText>
        <XText textAlign="|">
          {LocaleX.Parse({
            EN: "Results will be returned within 3 days from the date you submitted the receipt via your registered email.",
            TC: "結果將在您透過註冊電子郵件提交收據之日起 3 天內回傳。"
          })}
        </XText>
      </VStack>
    );
  }

  renderMain(){
    let {page} = this.state; 
    switch(page){
      default: case "view": return this.renderView();
      case "upload": return this.renderUpload();
      case "thank": return this.renderThank();
    }
  }

  renderPageBtn(){
    let {page} = this.state; 
    switch(page){
      default: case "view": 
        return (
          <XButton bW={1} onPress={this._toUpload}
            style={{
              borderColor: ColorX.CSS("Axit")
            }} color={ColorX.CSS("Axit")} pH={20} round={50}>
            <HStack spacing={10}>
              <IoDocumentTextOutline/>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Upload receipt",
                  TC: "上傳收據"
                })}
              </XText>
            </HStack>
          </XButton>
        );
      case "upload": 
      case "thank": 
      return (
        <XButton bW={1} onPress={this._toView}
          style={{
            borderColor: ColorX.CSS("Axit")
          }} color={ColorX.CSS("Axit")} pH={20} round={50}>
          <HStack spacing={10}>
            <XText bold>
              {LocaleX.Parse({
                EN: "Back to Receipt details",
                TC: "返回收據詳情"
              })}
            </XText>
          </HStack>
        </XButton>
      );
    }
  }

  renderButtons(){
    let {page} = this.state;
    return (
      <HStack HAlign="]" 
        style={{
          borderTopWidth: 1,
          borderTopColor: ColorX.CSS("greyOut", 0.5),
          borderTopStyle: "solid"
        }} mT={20} p={16} spacing={20}>
        <XButton onPress={this._toClose} color={ColorX.CSS("Axit")}
          padding={5}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Close",
                TC: "關閉"
              })}
            </XText>
          </HStack>
        </XButton>
        {page !== "thank" && 
          <XButton onPress={this._toSubmit} pH={35} round={50}
            bgColor={ColorX.CSS("Axit")}
            color={ColorX.CSS("pureWhite")}
            padding={8} disabled={page !== "upload" ||
              !this._validateForm()
            }>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Submit receipts",
                  TC: "提交收據"
                })}
              </XText>
            </HStack>
          </XButton>}
      </HStack>
    );
  }

  render(){
    return (
      <VStack bgColor={ColorX.CSS("NotQuiteWhite")} width={750}>
        {this.renderHeader()}
        <VStack p={16} fullWidth>
          {this.renderPolicy()}
          {this.renderMain()}
        </VStack>
        {this.renderPageBtn()}
        {this.renderButtons()}
      </VStack> 
    );
  }

}

export default observer(PAPopupReceipts);
